module.exports = __webpack_public_path__ + "img/symbol_8.f73ff0b1.png";